import { DetailsList, IconButton, PrimaryButton, SelectionMode, SharedColors } from "@fluentui/react";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { Link, useOutletContext, useParams } from "react-router-dom";
import AuthContext from "../../Services/AuthContext";
import AddVentureAddon from "../../Panel/VentureAddon/AddVentureAddon";
import EditVentureAddon from "../../Panel/VentureAddon/EditVentureAddon";
import CloneVentureAddon from "../../Panel/VentureAddon/CloneVentureAddon";
import { netGrossColumn, useNetGross } from "../../Utilities/NetGrossField";

function VentureAddon() {
    const [user] = useContext(AuthContext);
    const netGross = useNetGross();
    const {actions} = useOutletContext();
    const [addons, setAddons] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const params = useParams();
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/venture/${params.id}/addon`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    if (data[0].id !== null) {
                        setAddons(data);
                    } else {
                        setAddons([]);
                    }
                })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [params, refresh, user.token]);
    useEffect(() => {
        actions([
            {
                key: 'addAddon',
                text: 'Dodaj',
                iconProps: { iconName: 'Add' },
                onClick: () => setAddAddon({venture_id: params.id})
            },
            {
                key: 'cloneAddon',
                text: 'Importuj',
                iconProps: { iconName: 'Import' },
                onClick: () => setCloneAddon({venture_id: params.id})
            }
        ]);
        return actions;
    }, []);

    const [addAddon, setAddAddon] = useState(false);
    const [editAddon, setEditAddon] = useState(false);
    const [cloneAddon, setCloneAddon] = useState(false);

    const deleteAddon = (id) => {
        fetch(`/api/venture/${params.id}/addon/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { setRefresh(refresh + 1) })
            .catch(err => { console.log(err) })
    }
    const addonLink = (item) => {
        let color = SharedColors.cyanBlue10;
        if (item.count > 0) {
            if (item.count === item.done) {
                color = SharedColors.yellowGreen10;
            } else if (item.count === item.scheduled) {
                color = SharedColors.greenCyan10;
            } else {
                color = SharedColors.redOrange10;
            }

        }
        return (<Link to={`${item.id}`}><PrimaryButton styles={{root: {backgroundColor: color, borderColor: color}, rootHovered: {backgroundColor: color, borderColor: color}}} text={item.addon} /></Link>);

    }
    const [columns, setColumns] = useState([]);
    useEffect(() => {
        setColumns([
            {
                key: 'addon',
                name: 'Nazwa',
                ariaLabel: 'Opis dodatku',
                fieldName: 'addon',
                minWidth: 200,
                isRowHeader: true,
                isResizable: true,
                onRender: addonLink
            },
            {
                ...netGrossColumn('', 'price', 'Cena ')
            },
            {
                ...netGrossColumn('', 'cost', 'Koszt ')
            },
            {
                key: 'id',
                name: 'Akcje',
                ariaLabel: 'Akcje',
                minWidth: 120,
                onRender: (item) => (<span>
                <IconButton iconProps={ {iconName: 'edit' }} title='Edytuj' onClick={() => setEditAddon(item)}/>
                <IconButton iconProps={ {iconName: 'trash' }} title='Usuń' onClick={() => deleteAddon(item.id)}/>
            </span>)
            }
        ]);
    }, [netGross]);

    return (
        <>
            <DetailsList items={addons} columns={columns} selectionMode={SelectionMode.none}/>
            <AddVentureAddon add={addAddon} dismissPanel={() => setAddAddon(false)} onSuccess={() => setRefresh(refresh + 1)}/>
            <EditVentureAddon add={editAddon} dismissPanel={() => setEditAddon(false)} onSuccess={() => setRefresh(refresh + 1)}/>
            <CloneVentureAddon add={cloneAddon} dismissPanel={() => setCloneAddon(false)} onSuccess={() => setRefresh(refresh + 1)}/>
        </>
    );
}
export default VentureAddon;